
export const GatorProtectActionTypes = {
  GATOR_PROTECT_LOADING: 'GATOR_PROTECT_LOADING',
  GATOR_PROTECT_LIST_PLANS_REQUEST: 'GATOR_PROTECT_LIST_PLANS_REQUEST',
  GATOR_PROTECT_LIST_PLANS_SUCCESS: 'GATOR_PROTECT_LIST_PLANS_SUCCESS',
  GATOR_PROTECT_LIST_PLANS_FAILURE: 'GATOR_PROTECT_LIST_PLANS_FAILURE',
  GATOR_PROTECT_LIST_PLANS_SET: 'GATOR_PROTECT_LIST_PLANS_SET',
  GATOR_PROTECT_GET_PLAN_DETAILS_REQUEST: 'GATOR_PROTECT_GET_PLAN_DETAILS_REQUEST',
  GATOR_PROTECT_GET_PLAN_DETAILS_SUCCESS: 'GATOR_PROTECT_GET_PLAN_DETAILS_SUCCESS',
  GATOR_PROTECT_GET_PLAN_DETAILS_FAILURE: 'GATOR_PROTECT_GET_PLAN_DETAILS_FAILURE',
  GATOR_PROTECT_GET_PLAN_DETAILS_SET: 'GATOR_PROTECT_GET_PLAN_DETAILS_SET',
  GATOR_PROTECT_BUY_PRODUCT: 'GATOR_PROTECT_BUY_PRODUCT',
};
